import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentUser: {
      name: '',
      phone: '',
    },
    isAuctionLive: false
  },
  getters: {
    currentUser: state => {
      return state.currentUser;
    },
    isAuctionLive: state => {
      return state.isAuctionLive;
    },
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
  }
})

export default store